import {
  clearLoadingMessage,
  clearWindData,
  populateAqfxDataAsync,
  populateAwsDataAsync,
  populateFmsDataAsync,
  populateWindDirectionDataPromise,
  populateWindMagnitudeDataPromise,
  setLoadingMessage,
  setWindBarbData,
  setWindVelocityData,
  windDataLoadComplete,
  windDataLoadStarting
} from '../actions';
import * as ActionTypes from '../actions/actionTypes';
import {OVERLAY_KEYS, WIND_DATA_STATUS} from '../Constants';
import {createDeferred} from '../utils/deferred';
import {boundsEqual} from '../utils/wind_utils';

const _updateWindAsync = (store, time, times, last, count, check_active_layers) => {
  const dispatch = store.dispatch;
  const state = store.getState();
  const selected_time = state.time.selected_time;
  const overlays = state.overlays;

  const deferred1 = createDeferred();
  const deferred2 = createDeferred();
  dispatch(populateWindMagnitudeDataPromise(state.map.map_bounds, state.map.map_zoom, time, deferred1));
  dispatch(populateWindDirectionDataPromise(state.map.map_bounds, state.map.map_zoom, time, deferred2));

  Promise.all([deferred1.promise, deferred2.promise]).then(() => {
    if (selected_time === time) {
      dispatch(setWindBarbData(time));
      dispatch(setWindVelocityData(time));
    }
    if (last) {
      dispatch(windDataLoadComplete());
      dispatch(clearLoadingMessage());
    } else if (check_active_layers &&
               !overlays.active[OVERLAY_KEYS.WIND_BARBS] &&
               !overlays.active[OVERLAY_KEYS.WIND_ANIMATED]) {
      dispatch(clearWindData());
      dispatch(clearLoadingMessage());
    } else {
      _loadNextWindData(store, time, times, count);
    }
  });
};

const _loadWindData = (store, times, selected_time, check_active_layers) => {
  const dispatch = store.dispatch;
  dispatch(setLoadingMessage('Loading wind data...'));
  const startIndex = times.indexOf(selected_time);
  _updateWindAsync(store, times[startIndex], times, 1 === times.length, 0, check_active_layers);
};

const _loadNextWindData = (store, time, times, count) => {
  if (count < times.length) {
    let currentTimeIdx = times.indexOf(time);
    let idx = currentTimeIdx + 1 < times.length ? currentTimeIdx + 1 : 0;
    _updateWindAsync(store, times[idx], times, count + 1 === times.length, count + 1, true);
  }
};

export const orchestrateOverlayData = store => next => action => {
  const { overlays, time, map, wind_data, keycloak } = store.getState();
  const dispatch = store.dispatch;

  switch (action.type) {
    case ActionTypes.ACTIVATE_OVERLAY:
    case ActionTypes.TOGGLE_OVERLAY:
      // Detect an overlay getting turned on.
      if (!overlays.active[action.id]) {
        switch (action.id) {
          case OVERLAY_KEYS.WIND_BARBS:
          case OVERLAY_KEYS.WIND_ANIMATED:
            if (WIND_DATA_STATUS.NOT_LOADED === wind_data.status) {
              dispatch(windDataLoadStarting());
              _loadWindData(store, time.valid_times, time.selected_time, false);
            } else {
              store.dispatch(setWindBarbData(time.selected_time));
              store.dispatch(setWindVelocityData(time.selected_time));
            }
            break;

          case OVERLAY_KEYS.WEATHER_STATIONS:
            store.dispatch(populateAwsDataAsync());
            store.dispatch(populateAqfxDataAsync());
            break;

          case OVERLAY_KEYS.FUEL_MOISTURE_STATIONS:
            store.dispatch(populateFmsDataAsync(keycloak.token));
            break;

          default:
            break;
        }
      }
      break;

    case ActionTypes.SET_MAP_BOUNDS_AND_ZOOM:
      if (action.map_bounds && (!map.map_bounds || !boundsEqual(map.map_bounds, action.map_bounds))) {
        store.dispatch(setWindBarbData(time.selected_time));
      }
      break;

    case ActionTypes.SET_ACTIVE_TIME:
      if (overlays.active[OVERLAY_KEYS.WIND_BARBS]) {
        store.dispatch(setWindBarbData(action.selected_time));
      }
      if (overlays.active[OVERLAY_KEYS.WIND_ANIMATED]) {
        store.dispatch(setWindVelocityData(action.selected_time));
      }
      break;

    default:
      break;
  }

  return next(action);
};



// WEBPACK FOOTER //
// ./src/middleware/overlayMiddleware.js